module.exports = __webpack_public_path__ + "img/f88ea009ebca761416f1a6f17f0f9bf2.svg";